import { useState, useEffect } from 'react'
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import LoadingSpinner from '../../../../../components/LoadingSpinner/LoadingSpinner'
import ConfirmationModal from '../../../../../components/ConfirmationModal'
import { useLoading } from '../../../../../hooks/LoadingContext'
import DashboardLayout from '../../../../../layouts/Dashboard/index'
import api from '../../../../../services/api'
import { errorApi } from '../../../../../utils/errorApi'

import styles from './styles.module.css'

const EntregasProblemasEditar: React.FC = () => {
  let { id } = useParams()
  const navigate = useNavigate()
  const { isLoading, setIsLoading } = useLoading()

  const [requestDeliveryDriverNote, setRequestDeliveryDriverNote] = useState<string>('')
  const [deliveryProblemSolution, setDeliveryProblemSolution] = useState<string>('')

  const [request, setRequest] = useState<any>()

  const [showModalRemove, setShowModalRemove] = useState<boolean>(false)

  const isValidModel = () => {
    if (!request || !request.id || !requestDeliveryDriverNote || !requestDeliveryDriverNote.length)
      return false
    return true
  }

  useEffect(() => {
    const loadRequestData = async () => {
      setIsLoading(true)
      try {
        let { data } = await api.get(`/delivery-manager/requests/${id}`)
        let requestIdentifier = data.invoice_number
          ? `NF nº ${data.invoice_number}`
          : data.request_number
            ? `Pedido nº ${data.request_number}`
            : `NFe nº ${data.invoice.substring(0, 10)}...`

        data.name = `${requestIdentifier} | ${data.receiver_name}`

        setRequestDeliveryDriverNote(data.request_delivery_driver_note)
        setDeliveryProblemSolution(data.delivery_problem_solution_note)
        setRequest(data)
      } catch (err) {
        toast.error(
          errorApi(err, 'Falha ao buscar os dados da requisição de entrega! Atualize a página.'),
        )
      }
      setIsLoading(false)
    }
    loadRequestData()
  }, [setIsLoading, id])

  const handleSubmit = async (operation: 'edit' | 'remove') => {
    setIsLoading(true)
    try {
      await api.put(`/delivery-manager/requests/${request.id}`, {
        request_delivery_driver_note: operation === 'edit' ? requestDeliveryDriverNote : null,
        delivery_problem_solution_note: operation === 'edit' ? deliveryProblemSolution : null,
        delivery_had_problems: operation === 'edit' ? true : false,
      })

      toast.info(
        `O problema ocorrido foi ${operation === 'edit' ? 'editado' : 'removido'} com sucesso!`,
        { autoClose: 3000 },
      )
      setIsLoading(false)
      navigate('/gestor-entregas/entregas/problemas')
    } catch (err) {
      toast.error(errorApi(err, 'Falha ao cadastrar o problema ocorrido! Verifique os dados.'))
      setIsLoading(false)
    }
  }

  return (
    <DashboardLayout backgroundColor="#F8F8F8" pageName="Editar problema">
      <LoadingSpinner text="Salvando informações. Aguarde..." />
      <Container>
        <h2 style={{ textAlign: 'center' }}>Editar problema ocorrido</h2>
        <p style={{ textAlign: 'center' }}>
          {request && request.name ? request.name : 'Requisição desconhecida'}
        </p>

        <Col className={styles.formContainer}>
          <Row style={{ marginTop: 0, textAlign: 'left' }}>
            <Col style={{ marginTop: 15 }}>
              <Form.Label className={styles.label}>Descrição do problema</Form.Label>
              <Form.Control
                className={styles.input}
                style={{
                  resize: 'none',
                }}
                as="textarea"
                rows={3}
                placeholder="Descreva o problema ocorrido"
                value={requestDeliveryDriverNote}
                onChange={(event) => setRequestDeliveryDriverNote(event.target.value)}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: 15, textAlign: 'left' }}>
            <Col>
              <Form.Label className={styles.label}>Solução do problema</Form.Label>
              <Form.Control
                className={styles.input}
                style={{
                  resize: 'none',
                }}
                as="textarea"
                rows={3}
                placeholder="Descreva a solução para o problema ocorrido"
                value={deliveryProblemSolution}
                onChange={(event) => setDeliveryProblemSolution(event.target.value)}
              />
            </Col>
          </Row>
          <Col style={{ marginTop: 15, textAlign: 'right' }}>
            <Button
              className={styles.deleteBtn}
              disabled={isLoading}
              onClick={() => setShowModalRemove(true)}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Remover problema'
              )}
            </Button>
            <Button
              className={styles.btn_submit}
              disabled={isLoading || !isValidModel()}
              onClick={() => handleSubmit('edit')}
            >
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                'Editar problema'
              )}
            </Button>
          </Col>
        </Col>
      </Container>
      <ConfirmationModal
        show={showModalRemove}
        message="Tem certeza de que deseja remover o problema ocorrido?"
        action={() => handleSubmit('remove')}
        closeModal={() => setShowModalRemove(false)}
      ></ConfirmationModal>
    </DashboardLayout>
  )
}

export default EntregasProblemasEditar
